/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Not_AuthorizedInputs */

const en_page_title_not_authorized = /** @type {(inputs: Page_Title_Not_AuthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not authorized`)
};

const nl_page_title_not_authorized = /** @type {(inputs: Page_Title_Not_AuthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen toegang`)
};

/**
* | output |
* | --- |
* | "Not authorized" |
*
* @param {Page_Title_Not_AuthorizedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_not_authorized = /** @type {((inputs?: Page_Title_Not_AuthorizedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Not_AuthorizedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_not_authorized(inputs)
	return en_page_title_not_authorized(inputs)
});